import type { Event } from '@cocoonspace/sdk-js/types/event'
import { TwicImg } from '@twicpics/components/react'
import type { ComponentProps } from 'react'
import { Skeleton } from '~/components/ui/skeleton'
import { DeskTypeBadge } from '~/domains/spaces/components/desk-type-badge'
import { cn } from '~/lib/utils'

export const EventCardSpacePreview = ({
	event,
	...props
}: {
	event: Event
	onClick?: () => void
} & ComponentProps<'div'>) => {
	return (
		<div
			{...props}
			className={cn(props.className, {
				'cursor-pointer': !!props.onClick,
			})}
		>
			<div className='relative mb-2 h-[156px] overflow-hidden rounded bg-slate-200/30'>
				{event.space?.images?.length && (
					<TwicImg
						src={`spaces/${event.space?.images[0].id}`}
						alt={event.space?.title}
						ratio='16/9'
						focus='50px100p'
					/>
				)}

				{event.type === 'desk' && (
					<DeskTypeBadge
						type={event.space?.desk_type}
						className='absolute bottom-4 left-0 rounded-l-none'
					/>
				)}
			</div>

			<div className='truncate font-bold'>{event.space?.title}</div>
		</div>
	)
}

EventCardSpacePreview.skeleton = () => (
	<div>
		<Skeleton className='mb-2 h-[156px] w-full' />

		<Skeleton className='h-[16px] w-full' />
	</div>
)
